import * as React from "react";
import PropTypes from "prop-types";
import IconBase from "./IconBase";

const SpeakerIcon = (props) => (
  <IconBase {...props} defaultPathColor="#333244" forceDefaultPath={true}>
    <rect x={74} y={40} width={2} height={4} rx={1} fill="#333244" />
    <rect x={77} y={38} width={2} height={8} rx={1} fill="#333244" />
    <rect x={80} y={40} width={2} height={4} rx={1} fill="#333244" />
  </IconBase>
);

SpeakerIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeColor: PropTypes.string,
  fillColor: PropTypes.string,
  pathColor: PropTypes.string,
};

export default SpeakerIcon;
